var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import { action, observable, reaction, extendObservable, toJS } from 'mobx';

import API from './api';

import qs from 'qs';

import { userStore } from 'sdc-auth-user';
import * as store from 'sdc-mobx-stores';
import { requiredParam } from 'sdc-utilities';
import { maybeCall } from 'sdc-utilities';

import { nestedMode, fieldValue, setFieldValue } from 'sdc-data-models';

import { editingMode } from './mode';
import { editingType } from './type';

/** class the Editing store
  @param {store} typesStore - the types store
  @param {API} api - the backend API to use
*/

export var EditingStore = (_class = function (_store$StandardStore) {
  _inherits(EditingStore, _store$StandardStore);

  function EditingStore(_ref) {
    var _ref$typesStore = _ref.typesStore,
        typesStore = _ref$typesStore === undefined ? requiredParam('typesStore') : _ref$typesStore,
        options = _objectWithoutProperties(_ref, ['typesStore']);

    _classCallCheck(this, EditingStore);

    var _this = _possibleConstructorReturn(this, _store$StandardStore.call(this, _extends({}, options, { entryName: 'entry' })));

    _initDefineProp(_this, 'snapshot', _descriptor, _this);

    _initDefineProp(_this, '_sending', _descriptor2, _this);

    _initDefineProp(_this, 'lastUpdate', _descriptor3, _this);

    _initDefineProp(_this, 'currentField', _descriptor4, _this);

    _initDefineProp(_this, 'currentLocale', _descriptor5, _this);

    _initDefineProp(_this, 'namedStores', _descriptor6, _this);

    _initDefineProp(_this, 'choices', _descriptor7, _this);

    _initDefineProp(_this, 'selectedText', _descriptor8, _this);

    _this.updateListener = null;

    _initDefineProp(_this, 'digestUpdate', _descriptor9, _this);

    _this.publishUpdate = function () {
      if (_this.updateListener && _this.updateListener.update) {
        maybeCall(_this.updateListener.patchBeforeUpdate)(_this._sending);
        _this.updateListener.update(_this._sending);
      } else _this.update(_this._sending);
    };

    _initDefineProp(_this, 'setBuffers', _descriptor10, _this);

    _this.onHistory = function (location, action) {
      var entry = qs.parse(location.hash.substring(2));

      if (entry.id && entry.type) {
        var type = _this.typesStore.typesByID[entry.type];
        if (type && type.key) {
          //editingMode.setMode('edit')
          editingType.setType(null);
          if (nestedMode()) {
            _this.setSelected({ values: {} });
          } else {
            _this.setSelected({});
          }
          setTimeout(function () {
            editingType.setType(type.key);
          }, 1);
          setTimeout(function () {
            _this.load(entry);
          }, 100);
        }
      }
    };

    _this.load = function (entry) {
      return store.defer(function (deferred) {
        store.async(_this.api.load(entry)).then(_this.updateEntry(deferred));
      });
    };

    _this.beforeUpdate = function (entry) {
      if (_this.typesStore.fields.creator && !fieldValue(entry, 'creator') && userStore.user.name) {
        setFieldValue(entry, 'creator', userStore.user.name);
      }
      if (nestedMode() && _this.typesStore.fields.created && !entry.values.created) {
        entry.values.created = new Date().valueOf();
      }
      if (nestedMode() && _this.typesStore.fields.owner && !entry.values.owner && userStore.user.id) {
        entry.values.owner = userStore.user.id;
      }
      if (nestedMode() && _this.typesStore.fields.updater && userStore.user.name) {
        entry.values.updater = userStore.user.name;
      }
      if (nestedMode() && _this.typesStore.fields.updated) {
        entry.values.updated = new Date().valueOf();
      }
    };

    _this.afterUpdate = function (entry) {
      if (_this.updateListener && _this.updateListener.updateSelected) {
        _this.updateListener.updateSelected(entry);
      }
    };

    _initDefineProp(_this, 'updateFieldWith', _descriptor11, _this);

    _this.selectField = function (field, locale) {
      return action(function (e) {
        _this.currentField = field;
        _this.currentLocale = locale || {};
        if (field.localize && locale !== undefined) {
          var values = _this._sending.values || {};
          var fieldRef = values[field.key];
          if (typeof fieldRef === 'string') {
            var _field$key, _extends2, _field$key2, _extends3, _field$key3, _extends4;

            console.log('String found - needs to be moved');
            var defaultLocale = { key: 'en' //spacesStore.selected.locales[0]
            };_this.selected.values = _extends({}, values, (_extends2 = {}, _extends2[field.key] = (_field$key = {}, _field$key[defaultLocale.key] = fieldRef, _field$key), _extends2));
            _this._sending.values = _extends({}, values, (_extends3 = {}, _extends3[field.key] = (_field$key2 = {}, _field$key2[defaultLocale.key] = fieldRef, _field$key2), _extends3));
            _this.snapshot.values = _extends({}, values, (_extends4 = {}, _extends4[field.key] = (_field$key3 = {}, _field$key3[defaultLocale.key] = fieldRef, _field$key3), _extends4));
          }
        }
      });
    };

    _this.updateField = function (field, locale) {
      var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return function (e) {
        var value = (typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object' ? field.dataType === 'boolean' ? e.target.checked : e.target.value || e.target.textContent : e;
        _this.updateFieldWith(field, locale, value, immediate);
      };
    };

    _this.setChoices = function (typeID) {
      return function (deferred) {
        return action(function (payload) {
          _this.choices[typeID] = payload.entries;
          deferred.resolve([]);
        });
      };
    };

    _this.publishAssignment = function (field, value, values) {
      if (_this.updateListener && _this.updateListener.update) {
        maybeCall(_this.updateListener.patchBeforeUpdate)(_this._sending);
        _this.updateListener.update(_this._sending, field, value, values);
      } else _this.api.assign(_this._sending, field, value, values)();
    };

    _this.assign = function (field) {
      return action(function (assignment) {
        if (field.multiple) {
          var values = assignment ? Array.isArray(assignment) ? assignment.map(function (e) {
            return e.value;
          }) : [assignment.value] : [];
          setFieldValue(_this.selected, field.key, values);
          setFieldValue(_this._sending, field.key, values);
          setFieldValue(_this.snapshot, field.key, values);
          _this.publishUpdate();
          _this.publishAssignment(field, null, values);
        } else {
          var value = assignment ? assignment.value : null;
          setFieldValue(_this.selected, field.key, value);
          setFieldValue(_this._sending, field.key, value);
          setFieldValue(_this.snapshot, field.key, value);
          _this.publishUpdate();
          _this.publishAssignment(field, value, []);
        }
      });
    };

    _this.updateChoice = function (field) {
      return action(function (assignment) {
        if (field.multiple) {
          var values = assignment ? assignment.map(function (e) {
            return e.value;
          }) : [];
          setFieldValue(_this.selected, field.key, values);
          setFieldValue(_this._sending, field.key, values);
          setFieldValue(_this.snapshot, field.key, values);
          _this.publishUpdate();
        } else {
          var value = assignment ? assignment.value : null;
          setFieldValue(_this.selected, field.key, value);
          setFieldValue(_this._sending, field.key, value);
          setFieldValue(_this.snapshot, field.key, value);
          _this.publishUpdate();
        }
      });
    };

    _initDefineProp(_this, 'textSelected', _descriptor12, _this);

    _this.typesStore = typesStore;

    reaction(function () {
      return _this.selected.id;
    }, function (id) {
      if (_this.snapshot.id !== id) {
        if (id) {
          _this.snapshot = extendObservable({}, toJS(_this.selected));
          _this._sending = extendObservable({}, toJS(_this.selected));
        } else {
          _this.snapshot = {};
          _this._sending = {};
          _this.currentField = {};
        }
      }
    });
    reaction(function () {
      return _this.lastUpdate;
    }, function (lastUpdate) {
      if (_this.snapshot.id === _this.selected.id) {
        _this.publishUpdate();
      }
    }, {
      delay: 1500
    });
    return _this;
  }

  return EditingStore;
}(store.StandardStore), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'snapshot', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, '_sending', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'lastUpdate', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'currentField', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'currentLocale', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'namedStores', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'choices', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'selectedText', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'digestUpdate', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (entry) {
      if (entry && entry.id && entry.id === _this2.snapshot.id) {
        _this2.selected = extendObservable({}, toJS(entry));
        _this2.snapshot = extendObservable({}, toJS(entry));
      }
    };
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'setBuffers', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (entry) {
      if (!_this3.lastUpdate || new Date().valueOf() - _this3.lastUpdate > 3000) {
        _this3.snapshot = extendObservable({}, toJS(entry));
        _this3._sending = extendObservable({}, toJS(entry));
      }
    };
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'updateFieldWith', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (field, locale, value, immediate) {
      var values = _this4._sending.values || {};
      var fieldRef = fieldValue(_this4._sending, field.key);
      var currentValue = field.localize && locale !== undefined ? (fieldRef || {})[locale.key] : fieldRef;
      if (currentValue !== value || field.dataType === 'boolean') {
        if (field.localize && locale !== undefined) {
          if (nestedMode()) {
            var _extends5, _extends6;

            var existing = values[field.key];
            _this4._sending.values = _extends({}, values, (_extends6 = {}, _extends6[field.key] = _extends({}, existing, (_extends5 = {}, _extends5[locale.key] = value, _extends5)), _extends6));
          } else {
            var _extends7;

            var _existing = _this4._sending[field.key];
            _this4._sending[field.key] = _extends({}, _existing, (_extends7 = {}, _extends7[locale.key] = value, _extends7));
          }
        } else {
          if (nestedMode()) {
            var _extends8;

            _this4._sending.values = _extends({}, values, (_extends8 = {}, _extends8[field.key] = value, _extends8));
          } else {
            _this4._sending[field.key] = value;
          }
        }
        _this4.currentField = field;
        if (immediate) {
          _this4.publishUpdate();
        } else {
          _this4.lastUpdate = new Date().valueOf();
        }
      }
    };
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'textSelected', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (e) {
      var content = e.target.value || e.target.textContent || '';
      _this5.selectionStart = e.target.selectionStart;
      _this5.selectionEnd = e.target.selectionEnd;
      _this5.selectedText = content.substring(_this5.selectionStart, _this5.selectionEnd);
    };
  }
})), _class);

export default (function (_ref2) {
  var backend = _ref2.backend,
      _ref2$api = _ref2.api,
      api = _ref2$api === undefined ? API : _ref2$api,
      options = _objectWithoutProperties(_ref2, ['backend', 'api']);

  return new EditingStore(_extends({}, options, { api: api({ backend: backend }) }));
});